module.exports = __webpack_public_path__ + "img/86059053.382e286a.png";